<template>
  <view-wrapper
    prefix="Create new"
    name="Counter"
    path="counters"
    :showCancel="true"
    saveText="Save"
    :saveFunc="save"
    :hasChangesBeenMade="hasChangesBeenMade"
    :validation="validation"
    :loading="loading"
  >
    <wrapper :checkForChildFocused="true" class="p-5 pt-10 mb-3" :focus="name !== ''">
      <grafokett-input
        class="w-96"
        v-model="name"
        :editable="true"
        labelPlaceholder="Name (required)"
      />
    </wrapper>

    <wrapper :checkForChildFocused="true" class="p-5 mb-3">
      <grafokett-input
        class="w-96"
        v-model="description"
        :editable="true"
        labelPlaceholder="Description (optional)"
      />
    </wrapper>

    <wrapper :checkForChildFocused="true" class="p-5 mb-3">
      <grafokett-input
        class="w-96"
        type="number"
        v-model="startValue"
        :editable="true"
        labelPlaceholder="Start value"
      />
    </wrapper>

    <wrapper :checkForChildFocused="true" class="p-5 mb-3">
      <grafokett-input
        class="w-96"
        type="number"
        v-model="currentValue"
        :editable="true"
        labelPlaceholder="Current value"
      />
    </wrapper>

    <wrapper :checkForChildFocused="true" class="p-5 mb-3">
      <grafokett-input
        class="w-96"
        type="number"
        v-model="stepValue"
        :editable="true"
        labelPlaceholder="Step value"
      />
    </wrapper>

    <wrapper :checkForChildFocused="true" class="p-5 mb-3">
      <grafokett-input
        class="w-96"
        type="number"
        v-model="zeroPadLength"
        :editable="true"
        labelPlaceholder="Zero-pad length (optional)"
      />
    </wrapper>

    <modal
      v-if="error"
      @close="error = false"
      type="error"
      heading="Error"
      :description="errorText"
    />
  </view-wrapper>
</template>

<script>
import GrafokettInput from "../components/forms/Input.vue";
import Modal from "../components/Modal";

export default {
  components: {
    GrafokettInput,
    Modal,
  },
  data() {
    return {
      name: "",
      description: "",
      startValue: 0,
      currentValue: 0,
      stepValue: 1,
      zeroPadLength: null,
      loading: false,
      error: false,
      errorText: "",
    };
  },
  methods: {
    parseOptionalInt(value, fallback = null) {
      if (value === null || value === undefined || value === "") return fallback;
      const parsed = parseInt(value, 10);
      return Number.isNaN(parsed) ? fallback : parsed;
    },
    validation() {
      return this.name !== "" && this.name != null;
    },
    hasChangesBeenMade() {
      return this.name !== "";
    },
    async save() {
      this.loading = true;
      try {
        await this.$store.dispatch("COUNTERS/CREATE_COUNTER", {
          name: this.name,
          description: this.description || null,
          startValue: this.parseOptionalInt(this.startValue, 0),
          currentValue: this.parseOptionalInt(this.currentValue, 0),
          stepValue: this.parseOptionalInt(this.stepValue, 1),
          zeroPaddedLength: this.parseOptionalInt(this.zeroPadLength, null),
        });
        this.$router.push("/counters");
      } catch (e) {
        this.error = true;
        this.errorText =
          (e && e.response && e.response.data && e.response.data.Message) ||
          "Could not create counter";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
